import React from 'react';
// import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import moment from 'moment';
import BaseComponent from 'components/BaseComponent';
import { FlexColContainer } from 'components/StyledComp';
import Calendar from 'components-desktop/Calendar';
import ChangeHistoriesButton from 'components-desktop/histories/ChangeHistoriesButton';
import misc from 'misc/misc';

const propTypes = {
};

@autobind
class CaregiverCalendar extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.id = this.parseQueryParam('id', this.props.location);
  }

  getCaregiverVisits(fromDateString, toDateString) {
    const params = {
      caregiverId: this.id,
      fromDate: misc.toDateString(moment(fromDateString, 'MM/DD/YYYY')),
      toDate: misc.toDateString(moment(toDateString, 'MM/DD/YYYY')),
    };
    return this.callServiceForRemoteObjects('/schedule_visit/get_list', params);
  }

  renderContent() {
    const { ...layoutProps } = this.props;

    return (
      <FlexColContainer
        {...layoutProps}
        padding="20px 20px"
      >
        <ChangeHistoriesButton
          width="wrap_content"
          height="wrap_content"
          margin="0 0 20px 0"
          alignSelf="flex-end"
          title="Change History"
          table="ScheduleVisit"
          caregiverId={Number(this.parseQueryParam('id', this.props.location))}
        />

        <Calendar
          ref={(ref) => { this.calendar = ref; }}
          width="match_parent"
          height="wrap_content"
          fetchVisits={this.getCaregiverVisits}
          showPatient
          showCaregiver={false}
        />
      </FlexColContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
CaregiverCalendar.propTypes = propTypes;

export default CaregiverCalendar;
